/**
 * The link a member sends to bring someone in. `base` is the app's PUBLIC url
 * (`COACH_URL`), never `window.location.origin`: inside the phone app that
 * origin is `app.<domain>`, which is not a website. The signup screen reads
 * `?ref=` and, under `links_only`, is the only way in.
 */
export function inviteLink(base: string, shareRef: string | null | undefined): string | null {
  if (!shareRef || !base) return null;
  return `${base.replace(/\/+$/, '')}/signup?ref=${encodeURIComponent(shareRef)}`;
}
